import {
  Button,
  Grid,
  TextField,
  Typography,
  Box
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { banUser } from '../../redux/slices/usersSlice';
import { useState } from 'react';
import { RootState } from '../../redux/store';
import { User } from '../../resources/types/usersTypes';

interface Props {
  user: User;
}

const UserBanContent = (props: Props) => {
  const { user } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const isSuperAdmin = useSelector(
    (state: RootState) => state.auth.info?.type === 'superAdmin'
  );

  const [banMessage, setBanMessage] = useState('');
  const [banMinmutes, setBanMinmutes] = useState(0);

  const onBanUser = () => {
    // eslint-disable-next-line no-restricted-globals
    const confirmation = confirm(
      t('userModal.confirmBanUser')
    );
    if (confirmation && user._id) {
      dispatch(banUser(user._id, { text: banMessage, minutes: banMinmutes }));
      alert(t('userModal.userBannedSuccess'));
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        {t('userModal.userLabel')} {user?.firstName} {user?.lastName} {user?.phone}
      </Typography>
      <Grid container spacing={2} direction='column'>
        <Grid item xs={10}>
          <TextField
            name='ban-message'
            label={t('userModal.banReason')}
            fullWidth
            value={banMessage}
            onChange={e => {
              setBanMessage(e.target.value ?? '');
            }}
          />
        </Grid>
        <Grid item xs={10}>
          <TextField
            name='ban-minutes'
            label={t('userModal.banMinutes')}
            type='number'
            fullWidth
            value={banMinmutes}
            onChange={e => {
              const minutes = Number(e.target.value ?? 0);
              setBanMinmutes(minutes < 0 ? 0 : minutes);
            }}
          />
        </Grid>
        {isSuperAdmin ? (
          <Grid item>
            <Button
              color='warning'
              variant='contained'
              disabled={banMessage.length < 3 || banMinmutes < 1}
              onClick={() => onBanUser()}
            >
              {t('userModal.banUserBtn')}
            </Button>
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
};

export default UserBanContent;
